/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ValidateIsrcResponseMatchesInner } from './ValidateIsrcResponseMatchesInner';
import {
    ValidateIsrcResponseMatchesInnerFromJSON,
    ValidateIsrcResponseMatchesInnerFromJSONTyped,
    ValidateIsrcResponseMatchesInnerToJSON,
} from './ValidateIsrcResponseMatchesInner';

/**
 * 
 * @export
 * @interface ValidateIsrcResponse
 */
export interface ValidateIsrcResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ValidateIsrcResponse
     */
    isDuplicate: boolean;
    /**
     * 
     * @type {string}
     * @memberof ValidateIsrcResponse
     */
    isrc: string;
    /**
     * 
     * @type {Array<ValidateIsrcResponseMatchesInner>}
     * @memberof ValidateIsrcResponse
     */
    matches: Array<ValidateIsrcResponseMatchesInner>;
}

/**
 * Check if a given object implements the ValidateIsrcResponse interface.
 */
export function instanceOfValidateIsrcResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "isDuplicate" in value;
    isInstance = isInstance && "isrc" in value;
    isInstance = isInstance && "matches" in value;

    return isInstance;
}

export function ValidateIsrcResponseFromJSON(json: any): ValidateIsrcResponse {
    return ValidateIsrcResponseFromJSONTyped(json, false);
}

export function ValidateIsrcResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateIsrcResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isDuplicate': json['isDuplicate'],
        'isrc': json['isrc'],
        'matches': ((json['matches'] as Array<any>).map(ValidateIsrcResponseMatchesInnerFromJSON)),
    };
}

export function ValidateIsrcResponseToJSON(value?: ValidateIsrcResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isDuplicate': value.isDuplicate,
        'isrc': value.isrc,
        'matches': ((value.matches as Array<any>).map(ValidateIsrcResponseMatchesInnerToJSON)),
    };
}

